import React from "react";
import { Box, Typography } from "@mui/material";

export const CheckCard = ({ text, value }) => {
  return (
    <Box className=" flex w-full place-content-between py-1">
      <Typography
        variant="body"
        fontSize={{ xs: "12px", sm: "13px", md: "16px" }}
        lineHeight={{ xs: "200%", sm: "180%" }}
        letterSpacing={"0.02em"}
        className="opacity-90"
        color={"primary"}
      >
        {text}
      </Typography>
      <Typography
        variant="body"
        fontSize={{ xs: "12px", sm: "13px", md: "16px" }}
        lineHeight={{ xs: "200%", sm: "180%" }}
        letterSpacing={"0.02em"}
        className="opacity-90"
        color={"primary"}
      >
        {value}
      </Typography>
    </Box>
  );
};
